import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AuthService from './AuthService';
import qs from 'qs';

class Login extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {
      userAuthenticated: this.Auth.userAuthenticated(),
      error: null
    };
  }

  initializePendo() {
    const authenticatedUser = this.Auth.getUser();
    console.log('authenticatedUser', authenticatedUser);

    return window.pendo.initialize({
      visitor: {
        id: authenticatedUser.id,
        email: authenticatedUser.email,
        full_name: authenticatedUser.name,
        admin: authenticatedUser.admin,
        inPersonSigning: authenticatedUser.enableInPersonSigning
      },
      account: {
        id: authenticatedUser.groupData.id,
        name: authenticatedUser.groupData.name,
        planLevel: authenticatedUser.groupData.billing.plan,
        userCount: authenticatedUser.groupData.userCount
      }
    });
  }

  render() {
    const { documents, keypad } = {
      documents: { pathname: '/documents' },
      keypad: { pathname: '/keypad' }
    };
    const { userAuthenticated, error } = this.state;

    if (userAuthenticated) {
      this.initializePendo();

      if (!localStorage.userGroup || localStorage.userGroup === false) {
        return <Redirect to={documents} />;
      } else {
        return <Redirect to={keypad} />;
      }
    } else {
      const code = qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true
      }).code;
      if (code && error == null) {
        this.Auth.exchangeToken(code).then(response => {
          if (response && response.user.sessionId) {
            this.setState(() => ({
              userAuthenticated: true
            }));
          } else {
            this.setState(() => ({
              error: true
            }));
          }
        });
      } else {
        window.location.assign(process.env.REACT_APP_FSID_LOGIN_URL);
      }
    }

    return null;
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/LoginPage.js